import { Divider, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Fragment } from "react";
import PropTypes from "prop-types";
import LensProductItem from "./lens-product-item";

export const LensProductSection = ({ salesOrderLensProducts }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Produk Lensa</Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          {salesOrderLensProducts.map((salesOrderLensProduct, index) => (
            <Fragment key={salesOrderLensProduct.id}>
              {index != 0 && <Divider sx={{ my: 2 }} />}
              <LensProductItem
                index={index}
                lensProduct={salesOrderLensProduct}
              />
            </Fragment>
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
};

LensProductSection.propTypes = {
  salesOrderLensProducts: PropTypes.array.isRequired,
};
